<template>
  <div
    class="pc-dashboard__notification-bar"
    v-if="showElement"
    @click="navigateToList()"
  >
    <div class="pc-dashboard__notification-bar__link">
      <text-content
        :size="'sm1'"
        :line-height="'multi'"
        :weight="'extra-bold'"
        :decoration="'underline'"
      >
        {{ notificationText }} >
      </text-content>
    </div>
  </div>
</template>
<script>
import TextContent from '../../../../root/TextContent'
import { mapGetters } from 'vuex'
import notificationBarMixin from '../../../../../mixins/component-mixins/global/notificationBarMixin'

export default {
  name: 'DashboardNotificationBar',
  components: { TextContent },
  mixins: [notificationBarMixin],
  watch:{
    showElement: {
      immediate: true,
      handler: function (val) {
        if (val) {
          document.body.classList.toggle('with-notification-bar', this.showElement)
        }
      }
    }
  },
  computed: {
    showElement: function (){
      return  Array.isArray(this.notificationList) &&this.notificationList.length > 0 && this.notificationBarShow && this.show
    },
    ...mapGetters({
      notificationBarSettings: 'pageStore/notificationBarSettings',
      notificationCount: 'getNotificationCount'
    }),
    notificationBarShow () {
      return (
        this.notificationBarSettings.show &&
          this.notificationCount > 0 &&
          !(this.params.page && this.params.page === 'notifications')
      )
    }
  },
  beforeDestroy() {
    document.body.classList.remove('with-notification-bar')
  },
}
</script>
